export const NAV = {
  brand: "nav-brand",
  link: (k) => `nav-link-${k}`,
  contactCta: "nav-contact-cta",
  mobileToggle: "nav-mobile-toggle",
  dropdown: (k) => `nav-dropdown-${k}`,
};

export const HERO = {
  section: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const SECTIONS = {
  audiences: "section-audiences",
  assetClasses: "section-asset-classes",
  services: "section-services",
  why: "section-why",
  portfolio: "section-portfolio",
  platform: "section-platform",
  esg: "section-esg",
  leadership: "section-leadership",
};

export const ASSET = { card: (slug) => `asset-card-${slug}` };
export const SERVICE = { card: (slug) => `service-card-${slug}`, link: (slug) => `service-link-${slug}` };

export const RFP = {
  form: "rfp-form",
  name: "rfp-name",
  company: "rfp-company",
  email: "rfp-email",
  phone: "rfp-phone",
  investorType: "rfp-investor-type",
  assetClass: "rfp-asset-class",
  message: "rfp-message",
  submit: "rfp-submit",
};

export const PAGE = { hero: (k) => `page-hero-${k}` };
export const FOOTER = { section: "footer-section", link: (k) => `footer-link-${k}` };
